<template>
    <div class="log-browse mb-3 mt-page">

        <b-row>
            <b-col>
                <h1>{{ $i18n.gt('HEADING_VIEW_LOGS') }}</h1>
            </b-col>
        </b-row>

        <data-table ref="dataTable"
                    :show-filters="true"
                    :show-pager="true"
                    :show-details="false"
                    :get-items="getEntries"
                    :filters="filters"
                    :fields="fields">
        </data-table>

    </div>
</template>

<script>

import Vue from 'vue'
import * as _ from 'lodash'

/**
 * Page to browse log entries
 */
export default Vue.extend({
    name: "LogBrowse",
    data() {
        return {
            types: [],
            fields: [
                {key: 'entry_type', sortable: true, label: 'Entry Type'},
                {key: 'userEmail', sortable: true, label: 'User Email'},
                {key: 'text', sortable: true, label: 'Entry Text'},
                {key: 'logged', sortable: true, label: 'Time'},
            ],
        }
    },
    computed: {
        filters() {
            return {
                entry_type: {
                    field: 'entry_type',
                    type: 'select',
                    value: null,
                    options: this.types,
                    label: 'Entry Type'
                },
                email: {field: 'email', type: 'string', value: null, label: 'User Email'},
            }
        }
    },
    created() {
        this.$api.getUserLogEntryTypes(this)
            .then((types) => {
                this.types = _.map(types, (type) => {
                    return {
                        value: type, text: type
                    }
                })
            })
    },
    methods: {
        getEntries(listParams) {
            return this.$api.getItems(this, 'user-log', this.filters, listParams)
        },
    },
})

</script>
